<template>
  <base-hm-input :id="$attrs['id']"
                 :class="[
                   $attrs['class'],
                   { 'has-inline-icon-left': hasSlot('icon-inline-left') },
                   { 'has-inline-icon-right': hasSlot('icon-inline-right') },
                 ]"
                 :label="label"
                 :help="help"
                 :has-focus="hasFocus"
                 :is-empty="isValueEmpty"
                 :name="name"
                 :cols="cols"
                 :hidden="hidden"
                 :style="iconCountStyleVariables"
                 :disabled="true"
                 @click="openRoute">
    <input :value="internalValue"
           :data-vv-as="label"
           :data-vv-name="name"
           :disabled="true"
           :readonly="true"
           type="text"
           class="hm-input__input"
           @focus="onFocus"
           @blur="onBlur"
           @mouseenter="hover = true"
           @mouseleave="hover = false">
    <div :class="[{ 'hm-input__icon--input-hover': hover }, { 'hm-input__icon--input-focus': hasFocus}]" class="hm-input__icon__wrapper hm-input__icon__wrapper--left">
      <slot :hover="hover" :focus="hasFocus" name="icon-inline-left"></slot>
    </div>
    <div :class="[{ 'hm-input__icon--input-hover': hover }, { 'hm-input__icon--input-focus': hasFocus}]" class="hm-input__icon__wrapper hm-input__icon__wrapper--right">
      <slot :hover="hover" :focus="hasFocus" name="icon-inline-right"></slot>
    </div>
  </base-hm-input>
</template>

<script>

import { isNil, isFunction, trim, isArray, isEmpty } from 'lodash';
import HmInputMixin from '@/mixins/HmInputMixin';

export default {
  name: 'HmInputLink',

  mixins: [HmInputMixin],

  props: {
    route: {
      type: Object,
      required: false,
    },
    url: {
      type: String,
      required: false,
    },
  },

  data: function () {
    return {
      hover: false,
    };
  },

  computed: {
    iconCountLeft: function () {
      const slot = this.getSlot('icon-inline-left');

      if (isNil(slot)) return 0;
      else if (isArray(slot)) return slot.filter(it => typeof it.tag !== 'undefined').length;
      else return 1;
    },
    iconCountRight: function () {
      let slot = this.getSlot('icon-inline-right');
      slot = isNil(slot) || !isFunction(slot) ? slot : slot();

      if (isNil(slot)) return 0;
      else if (isArray(slot)) return slot.filter(it => typeof it.tag !== 'undefined').length;
      else return 1;
    },
    iconCountStyleVariables: function () {
      return {
        '--icons-left': this.iconCountLeft,
        '--icons-right': this.iconCountRight,
      };
    },
  },

  methods: {
    openRoute() {
      if (!isEmpty(this.url)) {
        window.open(this.url, '_blank');
      } else {
        this.$router.push(this.route);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
   @import '~styles/components/lib/HmInput';
</style>

<style lang="scss">
  @import '~styles/import';

  .inline-button {
    @include icon-color($middlegray);
    @include icon-hover($text);
    &:hover {
      cursor: pointer;
    }
  }

  .component__hm-input-link {
    cursor: pointer!important;
    input {
      color: $blue!important;
      text-decoration: underline;
      cursor: pointer!important;
      pointer-events: none!important;
    }

    .inline-button {
      z-index: 2;
      background-color: $white;
      border: 1px solid $middlegray;

      &[disabled] {
        background-color: $lightgray;
      }

      &:last-child {
        border-top-right-radius: 0.3rem;
        border-bottom-right-radius: 0.3rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmInputLink.vue